import { queryOptions, useQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { listarMisSolicitudes } from "../services/mis-solicitudes-service";

/**
 * Carga las solicitudes del usuario actual (todas, no paginadas en MVP)
 * y el componente de "Última actividad" selecciona las 5 más recientes
 * por FechaUltimoEvento.
 *
 * Comparte la query key con `/solicitudes` para que un `invalidateQueries`
 * en cualquier mutation actualice también el dashboard.
 */
export const actividadRecienteQueryOptions = queryOptions({
  queryKey: qk.misSolicitudes,
  queryFn: listarMisSolicitudes,
  refetchInterval: 30_000,
  staleTime: 0,
});

/**
 * `enabled` evita disparar `GET /solicitudes/mias` para quien NO tiene permiso de
 * ver solicitudes (autorizadores puros) — ese endpoint responde 403 y la tarjeta
 * de actividad ni usa el dato en su caso (renderiza la bandeja). El llamador pasa
 * el gate por permiso, mismo criterio que el loader de la ruta `/solicitudes`.
 */
export function useActividadReciente(enabled = true) {
  return useQuery({ ...actividadRecienteQueryOptions, enabled });
}
